<template>
  <div class="dropdown-wrapper" v-if="!hidden">
    <p class="context">{{context}}:</p>
    <div class="options-wrapper">
      <div class="selected" :class="{open: open}" @click.prevent="toggleDropdown">
        {{selected}}
        <svg class="arrow-down-icon" :viewBox="'0 0 512 512'">
          <use :xlink:href="'#arrow-down-icon'"></use>
        </svg>
      </div>

      <div :class="[ 'items', { selectHide: !open } ]">
        <div v-for="(option, value) of options" :key="value"
          :class="['item', optionClasses]">
          <div v-if="!showCheckbox"
                @click="updateSingleSelected(option.name, option.value)">{{option.name}}</div>
          <label v-else class="label">
            <input type="checkbox" @change="updateMultiSelected(option)">
            <span class="checkbox"></span>
            <span>{{option}}</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    context: String,
    defaultOption: String,
    optionClasses: String,
    showCheckbox: Boolean,
    options: Array,
    hidden: {
      default: false,
      type: Boolean
    }
  },

  name: 'Dropdown',

  data() {
    return {
      selected: this.defaultOption,
      multiSelect: [],
      open: false
    }
  },

  methods: {
    loadData() {
      this.$emit('reloadData')
    },

    toggleDropdown () {
      this.open = !this.open
    },

    close (event) {
      if (!this.$el.contains(event.target)) {
        this.open = false
      }
    },

    getMultiSelect() {
      return this.multiSelect
    },

    closeDropdown() {
      this.open = !this.open
    },

    updateMultiSelected(value) {
      const index = this.multiSelect.indexOf(value)
      index < 0 ? this.multiSelect.push(value) : this.multiSelect.splice(index, 1)
      const multiSelectLength = this.multiSelect.length
      this.selected = this.getDisplayValue(multiSelectLength)
      this.$store.commit('SET_AD_REGION', { adRegion: this.multiSelect })
      this.loadData()
    },

    getDisplayValue(multiSelectLength) {
      if (this.options.length === multiSelectLength) {
          return this.defaultOption
      } else if (multiSelectLength === 1) {
          return this.multiSelect[0]
      } else if (multiSelectLength > 1) {
          return 'multiple'
      } else {
          return this.defaultOption
      }
    },

    updateSingleSelected(name, value) {
      this.selected = name
      this.$store.commit('SET_AD_SORT', { adSort: value })
      this.open = false
      this.loadData()
    },
  },

  mounted () {
    document.addEventListener('click', this.close)
  },

  beforeDestroy () {
    document.removeEventListener('click',this.close)
  }
}
</script>

<style lang="sass">
@import '../../assets/sass/colors'

.dropdown-wrapper
  display: flex
  position: relative
  width: max-content
  text-align: left
  outline: none
  height: 31px
  line-height: 30px

  .context
    font-size: 1em
    margin: 0

  .selected
    cursor: pointer
    user-select: none
    text-align: center
    width: 175px
    text-transform: lowercase

  .context, .selected
    border-bottom: solid 1px $primary-color

  .items
    background-color: white
    color: #000
    width: 175px
    border-radius: 0px 0px 10px 10px
    overflow: hidden
    border: solid 1px $primary-color
    position: absolute
    right: 0
    top: 30px
    z-index: 1

    .item
      cursor: pointer
      user-select: none

    .filter-items
      margin: 0 1em
      text-transform: lowercase

    .label
      align-items: center
      color: black
      cursor: pointer
      display: flex
      font-size: 1em
      position: relative

      .checkbox
        background-color: #fff
        border: 1px solid $primary-color
        border-radius: 5px
        display: block
        margin-right: .25rem
        height: 14px
        width: 14px

      input
        display: none

      input:checked ~ .checkbox
        background-color: $primary-color

  .open
    svg.arrow-down-icon
      transform: rotate(180deg)

  .sort-items
    text-align: center

.selectHide
  display: none

svg.arrow-down-icon
  fill: none
  height: 100%
  position: absolute
  right: 0
  stroke: $primary-color
  stroke-linecap: round
  stroke-linejoin: round
  stroke-width: 48
  transition: .4s all
  width: 20px
</style>